import { useField } from 'formik';
import React, { useCallback, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import Context from 'lib/context';

import Recto from './Recto';

const RectoContainer = (props) => {
  const { t } = useTranslation();
  const { theme } = useContext(Context);
  const [{ value: answer }, , { setValue: setAnswer }] = useField('answer');
  const fields = document.getElementsByClassName('field');
  const handleChoiceSelect = useCallback(
    (selectedChoice, index) => {
      const updatedAnswer = answer.map((currentChoice, i) =>
        index === i ? selectedChoice.trim() || ' ' : currentChoice,
      );
      setAnswer(updatedAnswer);
      // focus if the next blank is an input
      if (fields[index + 1] && fields[index + 1].children[0]) {
        fields[index + 1].children[0].focus();
      }
      // focus if the next blank is a select
      if (fields[index + 1]) {
        fields[index + 1].focus();
        // blur if no next blank
      } else {
        fields[index].blur();
      }
    },
    [answer, fields, setAnswer],
  );
  const handleEnter = useCallback((event) => {
    const isTargetInput = event.target.tagName === 'INPUT';
    const isTargetSelect = event.target.id.split('-').shift() === 'blank';
    const isKeyEnter = event.key === 'Enter';
    const isKeyInteger = Number.isInteger(Number(event.key));
    if (isTargetInput && isKeyEnter) {
      event.preventDefault();
    }
    if (isTargetSelect && isKeyInteger) {
      const blankIndex = event.target.id.split('-').pop();
      const choiceButton = document.getElementById(
        `choice-${blankIndex}-${event.key - 1}`,
      );
      if (choiceButton) {
        event.preventDefault();
        choiceButton.click();
      }
    }
  }, []);
  useEffect(() => {
    window.addEventListener('keydown', (event) => handleEnter(event));
    return () => {
      window.removeEventListener('keydown', handleEnter);
    };
  }, [handleEnter]);
  return (
    <Recto
      answer={answer}
      handleChoiceSelect={handleChoiceSelect}
      t={t}
      theme={theme}
      {...props}
    />
  );
};

RectoContainer.defaultAnswer = (question) =>
  (question.content.text.match(/\[{2}.*?\]*\]{2}|\{{2}.*?\}*\}{2}/g) || []).map(
    () => '',
  );

RectoContainer.validationSchema = () =>
  yup.object().shape({
    answer: yup.array().of(yup.string().trim()),
  });

export default RectoContainer;
